import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const reviews = [{
  name: 'Mr. T',
  role: 'Business Executive',
  quote: 'The level of professionalism and discretion is unmatched. My companion was not only stunning but incredibly intelligent.',
  rating: 5
}, {
  name: 'Mr. L',
  role: 'International Traveler',
  quote: 'SGHarem made my business trip to Singapore unforgettable. The booking process was seamless and the service was premium.',
  rating: 5
}, {
  name: 'Mr. K',
  role: 'VIP Member',
  quote: "I've used many services across Asia, but the quality of companions here is simply on another level. Highly recommended.",
  rating: 5
}];
export function Testimonials() {
  return <section className="py-24 bg-[#050505] relative overflow-hidden" data-id="element-414">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#c9a96e]/20 to-transparent" data-id="element-415" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-416">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-417">
          <h2 className="text-3xl md:text-4xl font-serif text-white mb-4" data-id="element-418">
            Client Reviews <span className="text-[#c9a96e]" data-id="element-419">客户评价</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-420">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#111111] p-8 rounded-xl border border-neutral-800 relative group hover:border-[#c9a96e]/30 transition-colors" data-id="element-421">
              <Quote className="absolute top-6 right-6 text-[#c9a96e]/10 group-hover:text-[#c9a96e]/20 transition-colors" size={48} data-id="element-422" />

              <div className="flex gap-1 mb-6" data-id="element-423">
                {[...Array(review.rating)].map((_, i) => <Star key={i} size={16} className="text-[#c9a96e] fill-[#c9a96e]" data-id="element-424" />)}
              </div>

              <p className="text-neutral-300 italic mb-8 leading-relaxed relative z-10" data-id="element-425">
                "{review.quote}"
              </p>

              <div className="flex items-center gap-4" data-id="element-426">
                <div className="w-10 h-10 rounded-full bg-neutral-800 flex items-center justify-center text-[#c9a96e] font-serif font-bold" data-id="element-427">
                  {review.name.charAt(4)}
                </div>
                <div data-id="element-428">
                  <p className="text-white font-medium" data-id="element-429">{review.name}</p>
                  <p className="text-xs text-neutral-500 uppercase tracking-wider" data-id="element-430">
                    {review.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}